export const DEFAULT_LANG = 'ID';

export const NOT_CLOSEABLE_MSG = [
  'TOAST_EVENT_END',
  'TOAST_EVENTOVER',
  'TOAST_EVENT_NOTOPEN',
  'TOAST_NETWORK_ERROR',
  'VISITOR_NOT_ALLOWED',
  'TOAST_SERVER_BUSY',
  'TOAST_WRONG_REGION',
  'TOAST_SERVER_TIMEOUT',
  'TOAST_LOGIN_FAILED',
  'TOAST_TOKEN_EXPIRED',
  'NOT_LOGGED_IN',
  'TOAST_EVENT_CLOSED_AWHILE',
  '?err=41',
  'NO_CHARACTER',
  'EVENT_CLOSED',
  `("ERROR GOP | {'ERROR': 'ERROR_TOKEN'}", 1)`,
  'EVENT_MAINTENANCE',
  'SERVER_ERR',
  'SETTING_ERROR',
  'UNDEFINED',
  'PLEASE REFRESH YOUR BROWSER!',
];

export const ERR_LOGIN = ['TOAST_LOGIN_FAILED', 'NOT_LOGGED_IN', `("ERROR GOP | {'ERROR': 'ERROR_TOKEN'}", 1)`];
export const WRONG_REGION = ['TOAST_WRONG_REGION', 'invalid_region'];
export const BLACKSCREEN_MSG = ['NOT_LOGGED_IN', 'TOAST_LOGIN_FAILED'];
export const ACCEPTED_PARAMS_TOKEN = ['access_token', 'gop_access_token', 'encodeparam'];
